import { Col, Row } from 'react-bootstrap';
import styles from './EmptyMessage.module.scss';

interface IProps {
  show: boolean;
  message: string;
  className?: string;
}

const EmptyMessage = (props: IProps) => {
  return (
    <>
      {props.show && (
        <Row className={props.className}>
          <Col className='text-center'>
            <span className={styles.emptyMessage}>{props.message}</span>
          </Col>
        </Row>
      )}
    </>
  );
};

export default EmptyMessage;
